let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f8cIm")).then(() => parcelRequire('bqE5a'));